import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b592b0f8&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b592b0f8",
  null
  
)

export default component.exports